import ApiProcessor from '../../processors/api-processor'

const TABLE_FILTERS = [
  {
    attribute: 'name',
    label: 'Provider Name',
    type: 'string',
    icon: 'el-icon-document',
  },
  {
    attribute: 'offersCount',
    label: 'Number of Offers',
    type: 'numeric',
    icon: 'el-icon-document',
  },
]

const TABLE_COLUMNS = [
  {
    name: 'name',
    label: 'Provider Name',
    icon: 'el-icon-document',
  },
  {
    name: 'offersCount',
    label: 'Number of Offers',
    icon: 'el-icon-document',
  },
]

export default component => {
  return {
    processor: new ApiProcessor({
      component,
      path: 'providers',
      initialDataQuery: { pageSize: 25 },
    }),
    filters: TABLE_FILTERS,
    columns: TABLE_COLUMNS,
    tableName: 'providers',
  }
}
